import { giphyIndigo } from '@giphy/colors'
import { useContext, useMemo, useState } from 'react'
import IconButton from 'ui/src/components/controls/icon-button'
import { UGEContext } from '../../../context'
import { useStickerCategories } from '../../../hooks/use-sticker-categories'
import { categoryFromSearchTerm, labelFromStickerCategory } from '../../../utilities/sticker-category'
import { Toolbar } from '../../style'
import { Categories, Input } from './style'

type Props = {
    className?: string
    searchTerm?: string
    onSearch: (term: string) => void
}

const UGEStickersEditorToolbar = ({ className, searchTerm = '', onSearch }: Props) => {
    const { fetchFavoriteStickers } = useContext(UGEContext)

    const categories = useStickerCategories(!!fetchFavoriteStickers)
    const category = categoryFromSearchTerm(searchTerm)
    const categoryIndex = useMemo(() => (category ? categories.indexOf(category) : -1), [categories, category])
    const [inputValue, setInputValue] = useState<string>(!category ? searchTerm : '')

    function onCategoryChange(index: number) {
        const category = categories[index]

        if (category && category !== searchTerm) {
            onSearch(category)
        }
    }

    function onInputSubmit() {
        if (inputValue) {
            onSearch(inputValue.replace('#', ''))
        }
    }

    return (
        <Toolbar className={className}>
            <Input
                autoFocus
                placeholder="Search all the stickers"
                size="small"
                value={inputValue}
                onChange={setInputValue}
                onEnterKeyPress={onInputSubmit}
            >
                <IconButton gradient="red-pink" icon="search" iconColor="#fff" size="small" onClick={onInputSubmit} />
            </Input>
            <Categories
                color={giphyIndigo}
                gradient="indigo-purple"
                index={categoryIndex}
                options={categories.map(labelFromStickerCategory)}
                size="small"
                onChange={onCategoryChange}
            />
        </Toolbar>
    )
}

export default UGEStickersEditorToolbar
